import { Badge, Card, Text, Toggle, Tooltip } from '@serodigital/ui-components';
import { kebabCase, startCase } from 'lodash';
import * as React from 'react';
import { useDetails } from '../state/detailsContext';
import { IControlPeripheral } from '../state/types';

interface IControlProps {
  control: IControlPeripheral;
}

function HeatPumpStatus({ control }: IControlProps) {
  const { deviceType, deviceCategory, state, hasPermission } = control;
  const { setControlPeripheralState } = useDetails();

  const onToggle = (status: boolean) => {
    setControlPeripheralState(deviceType, status);
  };

  return (
    <div className="flex flex-row">
      <div className="pr-96">
        <div className="pb-12">
          <Text>Heat Pump Status:</Text>
        </div>
        <Badge data-qa="heat-pump-status" className={state ? 'sero-bg-common-success' : 'sero-bg-common-error'}>
          {state ? 'ON' : 'OFF'}
        </Badge>
      </div>
      <div>
        <div className="pb-12">
          <Text>Heat Pump (OFF/ON)</Text>
        </div>
        <div className="flex items-center space-x-12">
          <Toggle checked={!!state} disabled={!hasPermission} onChange={onToggle} data-qa="heat-pump-toggle" />
          {!hasPermission && (
            <Tooltip
              data-qa={`${kebabCase(deviceCategory)}-control`}
              placement={'bottom'}
              TooltipComponent={() => (
                <Text data-qa="no-permission-message">
                  You do not have the correct account permissions <br />
                  to control a heat source.
                </Text>
              )}
              hasArrow={true}
            >
              <img
                src={require('../../../../assets/icons/information.svg')}
                alt="Information"
                width={22}
                data-qa="information-icon"
              />
            </Tooltip>
          )}
        </div>
      </div>
    </div>
  );
}

export function HeatPumpControl({ control }: IControlProps) {
  const { deviceCategory } = control;

  return (
    <Card data-qa={`${kebabCase(deviceCategory)}-control-card`}>
      <div className="flex flex-col sero-p-4">
        <Text className='sero-text-grey-primary-text sero-text-large' weight="bold">
          Home Controls
        </Text>

        <Text className='sero-text-grey-primary-text sero-text'>
          A collection of controls for physical devices within the home.
        </Text>
      </div>
      <div className='h-1 w-full sero-bg-grey-neutral my-16' />
      <div className="flex justify-between items-center sero-p-4">
        <Text className="sero-text-brand-primary sero-text-large" weight="bold">
          {startCase(deviceCategory)}
        </Text>
        <HeatPumpStatus control={control} />
      </div>
    </Card>
  );
}
